import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/vue'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ app }) => {
  Sentry.init({
    app,
    dsn: 'https://04955d3813b94023b1a930cf6d2851a7@o4505375761629184.ingest.sentry.io/4505375797084160',
    environment: process.env.NODE_ENV,
    tunnel: 'https://api.nowallied.com/sentry',
    // integrations: [
    //   new Sentry.BrowserTracing({
    //     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    //     tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //   }),
    //   Sentry.replayIntegration(),
    // ],
    trackComponents: true,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
})
